'use client'
import { useState, useEffect } from 'react'
import { Switch } from '@headlessui/react'
import { useRouter } from 'next/navigation'
import { updateSearchParams, removeSearchParam, getSearchParams } from "@utils";



function PetFriendlyFilter({ title, dictionary }) {
    const router = useRouter();

    const [petfriendly, setPetFriendly] = useState(false)

    const handleUpdateParams = (e) => {
        console.log(e)
        let newPathName
        if (e == true) {
            newPathName = updateSearchParams(title, e);
        } else {
            newPathName = removeSearchParam(title);
        }

        router.push(newPathName);
        router.refresh()
    };

    useEffect(() => {
        const petfriendlyValue = getSearchParams('petfriendly')

        if (petfriendlyValue == 'true') {
            setPetFriendly(true)
        } else {
            setPetFriendly(false)
        }
    }, [handleUpdateParams])

    return (
        <div className='w-full flex flex-row items-center justify-between mt-2 px-1'>
            <span className='text-sm text-secondary'>{dictionary.onlyIncludePetfriendly}</span>
            <Switch
                checked={petfriendly}
                // onChange={setPetFriendly}
                onChange={(value) => {
                    setPetFriendly(value)
                    handleUpdateParams(value)
                }}
                className={`${petfriendly ? 'bg-maincolor' : 'bg-forth'
                    } relative inline-flex h-6 w-11 items-center rounded-full border-[1px] border-forth shadow-sm`}
            >
                <span className="sr-only">Only Include Pet Friendly</span>
                <span
                    className={`${petfriendly ? 'translate-x-6' : 'translate-x-1'
                        } inline-block h-4 w-4 transform rounded-full bg-white transition`}
                />
            </Switch>
        </div>
    )
}

export default PetFriendlyFilter